<div class="row">
  <label [for]="id">{{ label }}</label>
  <span *ngIf="popoverTitle || popoverBody"
    class="popover-host"
    popoverClass="bciti-popover"
    [popoverTitle]="popTitle"
    [ngbPopover]="popoverBody"
    [class]="Icon.INFO"
  ></span>
</div>
<div class="form-input-wrap">
  <input  *ngIf="type!=='phone' && !mask"
  [autocomplete]="autocomplete"
  [id]="id"  
  [type]="type"
  [placeholder]="placeholder || label"
  [value]="value"
  [disabled]="disabled"
  [class.validation]="validation"
  [class.pristine]="pristine"
  [class.dirty]="dirty"
  [class.touched]="touched"
  [class.invalid]="invalid"
  [class.valid]="valid"
  [maxLength]="maxLength"
  [pattern]="pattern"
  [attr.inputmode]="inputmode"
  (input)="valueChange($event.target.value)"
  (blur)="onBlurEvent($event)" />

  <input  *ngIf="type!=='phone' && mask"
  [autocomplete]="autocomplete"
  [id]="id"  
  [type]="type"
  [placeholder]="placeholder || label"
  [value]="value"
  [disabled]="disabled"
  [class.validation]="validation"
  [class.pristine]="pristine"
  [class.dirty]="dirty"
  [class.touched]="touched"
  [class.invalid]="invalid"
  [class.valid]="valid"
  [textMask]="mask"
  [maxLength]="maxLength"
  [pattern]="pattern"
  [attr.inputmode]="inputmode"
  (input)="valueChange($event.target.value)"
  (blur)="onBlurEvent($event)" />

  <input  *ngIf="type==='phone'"
  [id]="id"  
  [type]="type"
  [placeholder]="label || placeholder"
  [value]="value"
  [disabled]="disabled"
  [class.validation]="validation"
  [class.pristine]="pristine"
  [class.dirty]="dirty"
  [class.touched]="touched"
  [class.invalid]="invalid"
  [class.valid]="valid"
  (input)="valueChange($event.target.value)"
  (blur)="onBlurEvent($event)" 
  maxlength="14"
  />

  <span *ngIf="appendButtonIcon"
    class="form-input-append-icon"
    (click)="buttonIconClicked($event)"
    [ngClass]="appendButtonIcon">
  </span>
  <span *ngIf="changeInput"
        class="form-input-append-icon"
        (click)="clearInput()"
        [ngClass]="Icon.CLOSE">
  </span>
</div>

<div *ngIf="hint" class="hint">
  {{ hint }}
</div>

<div class="messages" *ngIf="!disableMessages">
  <ng-content selector="app-form-error"></ng-content>
  <ng-content selector="app-form-success"></ng-content>
</div>

<ng-template #popTitle>
  {{ popoverTitle }} <span [class]="Icon.INFO"></span>
</ng-template>